import { Tooltip, TooltipContent, TooltipTrigger } from 'components/Tooltip';
import { Flex } from 'components/layout';
import { Typography } from 'components/typography/Typography';
import { QuickQuoteCustomAccessorial } from 'lib/api/getQuickQuoteCustomAccessorials';

export interface QuickQuoteCustomAccessorialTooltipRowProps {
  accessorial: QuickQuoteCustomAccessorial;
}

export function QuickQuoteCustomAccessorialTooltipRow({
  accessorial: acc,
}: QuickQuoteCustomAccessorialTooltipRowProps) {
  const hasDescription = acc.description.trim() !== '';
  const hasCharge = acc.charge.trim() !== '';
  const hasNotes = acc.notes.trim() !== '';
  const hasTooltipBody = hasDescription || hasCharge || hasNotes;

  return (
    <Tooltip delayDuration={10}>
      <TooltipTrigger asChild>
        <button
          type='button'
          className='w-full cursor-default border-0 bg-transparent p-0 text-left'
        >
          <Flex direction='col'>
            <Typography
              variant='body-xs'
              weight='semibold'
              className='text-info-600'
            >
              {acc.name}
            </Typography>
            {hasCharge ? (
              <Typography variant='body-xxs' className='text-info-600'>
                {acc.charge}
              </Typography>
            ) : null}
          </Flex>
        </button>
      </TooltipTrigger>
      <TooltipContent className='max-w-70'>
        <Flex direction='col' gap='xs'>
          {hasDescription ? (
            <>
              <Typography
                variant='body-xs'
                weight='semibold'
                className='text-neutral-800'
              >
                Description
              </Typography>
              <Typography variant='body-xs' className='text-neutral-600'>
                {acc.description}
              </Typography>
            </>
          ) : null}
          {hasCharge ? (
            <>
              <Typography
                variant='body-xs'
                weight='semibold'
                className='text-neutral-800'
              >
                Charge
              </Typography>
              <Typography variant='body-xs' className='text-neutral-600'>
                {acc.charge}
              </Typography>
            </>
          ) : null}
          {hasNotes ? (
            <>
              <Typography
                variant='body-xs'
                weight='semibold'
                className='text-neutral-800'
              >
                Notes
              </Typography>
              <Typography variant='body-xs' className='text-neutral-600'>
                {acc.notes}
              </Typography>
            </>
          ) : null}
          {!hasTooltipBody ? (
            <Typography variant='body-xs' className='text-neutral-600'>
              No additional details.
            </Typography>
          ) : null}
        </Flex>
      </TooltipContent>
    </Tooltip>
  );
}
